import { BaseService } from './base.service';
import { ErrorWrapper, ResponseWrapper } from './util';

export class AnalyticsService extends BaseService {
  static async trackSegmentCRO (data) {
    try {
      const utms = await BaseService.getUTMS();

      const config = {
        headers: {
          ...utms
        }
      }

      const response = await this.request({ auth: true }, 'v2').post(
        '/segment/cro/sse',
        data,
        config
      );
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async triggerNonAuthSegmentEvent(data) {
    try {
      /*
        {
          event: 'event_name',
        }
      */
      const response = await this.request({ auth: false }, 'v2').post(
        '/segment/trigger',
        data
      )
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async getProductFirstPurchase(patientid, productid) {
    try {
      const response = await this.request({ auth: true }).get(
        `/patient/${patientid}/product/${productid}/firstpurchase`
      )
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }

  static async submitNPSSurveyResponse(rating) {
    try {
      const response = await this.request({ auth: true }, 'v2').post(
        '/patient/followup/nps-survey',
        { rating }
      )
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}